/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skipped_SavedInputs */

const vi_einvoice_skipped_saved = /** @type {(inputs: Einvoice_Skipped_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghi nhận không xuất hóa đơn`)
};

/**

* @param {Einvoice_Skipped_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skipped_saved = /** @type {((inputs?: Einvoice_Skipped_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skipped_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skipped_saved(inputs)
});